<template>
  <gj-modal
    v-bind="$attrs"
    v-on="$listeners"
    :loading="loading"
    size="guide"
    :class="{
      'novice-guide': true,
      'guides2': true
    }"
    :visible.sync="modalVisible"
  >
    <template #content>
      <div>
        <div style="display: flex">
          <div class="leftPart">
            <div class="left-astigmatism">
              <img :src="leftastigmatism" class="leftastigmatism-bg" />
            </div>
            <div class="identification">
              <img :src="newbietask" class="newbietask-bg"/>
            </div>
            <div class="fireworks-icon">
              <img :src="fireworks" class="fireworks-bg"/>
            </div>
            <p class="remarks">做任务得积点，快来开启您的新手之旅吧~</p>
            <div>
              <!-- 新手任务列表 -->
              <div
                v-for="(task, index) in taskTypeList"
                :key="task.taskTypeCode"
                class="task-list"
                :class="{ 'task-list-active' : index == taskActiveIndex }"
                @click="selectTaskIndex(index)"
              >
                <div class="task-list-icon">
                  <gj-icon :iconfont="index == taskActiveIndex ? task.icon : task.activeIcon" class="size42"></gj-icon>
                </div>
                <div class="task-list-main">
                  <div class="shop">
                    {{ task.taskTypeName }}
                    <span class="speed">
                      <el-progress
                        class="progress-bar-progress"
                        :stroke-width="8"
                        :percentage="task.taskRate"
                        :format="format"
                      ></el-progress>
                    </span>
                  </div>
                  <p class="task-notes">
                    {{ task.desc }}
                  </p>
                </div>
                <div v-if="task.taskStatus == 'COMPLETED'" class="task-completion">
                  <img :src="taskcompletion" class="task-completion-icon"/>
                </div>
              </div>
            </div>
          </div>
          <div class="rightPart">
            <div>
              <i class="el-icon-close close-window" @click="closeOpen()"></i>
              <div class="rightAstigmatism">
                <img :src="astigmatism" class="rightAstigmatism" />
                <img :src="goldCoin1" class="rightgoldCoin1" />
                <img :src="goldCoin2" class="rightgoldCoin2" />
                <img :src="goldCoin3" class="rightgoldCoin3" />
              </div>
            </div>
            <div class="rightmodular" id="ul">
              <div
                v-for="(row, index) in taskTreeList"
                :key="row.id"
                class="concreteContent"
                :id="'li' + index"
              >
                <div class="gj-ml40">
                  <div class="flex">
                    <span class="task-title">{{ row.taskTypeName }}</span>
                    <span v-if="row.taskStatus == 'COMPLETED'" class="getRewards flex align-center">
                      <img :src="greenStar" class="img12 gj-ml10 " />
                      <span class="get-reward-text">{{ row.gpoint1 }}</span>
                    </span>
                    <span v-else class="getRewards2 flex align-center">
                      <img :src="greenStar2" class="img12 gj-ml10" />
                      <span class="get-reward-text2">{{ row.gpoint2 }}</span>
                    </span>
                  </div>
                  <div class="flex justify-between gj-mb10" style="width: 776px;">
                    <span class="video-tutorial">
                        <gj-link class="video-tutorial-text" type="text" :href="getVideoUrl(row.videoUrlCode)" target="_blank">查看视频教程</gj-link>
                        <!-- 查看视频教程 -->
                        <div class="dividing-Line"></div>
                        <span class="duration">总时长：{{ row.time }}</span>
                    </span>
                    <gj-button class="startBtn" size="small" type="primary" @click="startTask(row)">
                      {{ row.btn }}
                    </gj-button>
                  </div>
                  <template
                    v-for="(item, index) in row.itemArray">
                    <gj-tooltip :key="item.id" :content="item.status == 3 ? item.condition : ''">
                      <div
                        :class="{'color999': item.status == 3, 'list-tasks-now': item.status == 2, 'list-tasks': true}"
                        :style="index == row.itemArray.length - 1 ? { marginBottom: 0 } : null"
                      >
                      <div class="task-box">
                        <div class="task-name">{{ item.title }}</div>
                        <div :class="{
                          'task-status': item.status == 1,
                          'task-status-two': item.status == 2,
                          'task-status-three': item.status == 3 || item.status == 0
                        }">
                          {{ item.taskStatusDesc }}
                        </div>
                      </div>

                      <div class="task-dividing-Line"></div>
                      <div class="task-description">
                        {{item.content}}
                        <!-- 店铺授权为系统使用第一步，授权完成后可以在系统查看listing、销售订单、Review、Feedback等信息，系统还可以为您生成统计分析报表，辅助您分析销售数据 -->
                      </div>
                    </div>
                    </gj-tooltip>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="width: 100%; height: 64px; background: #ffffff">
          <el-button size="small" class="delay" @click="closeOpen()"
            >稍后再做任务</el-button
          >
        </div>
      </div>

      <!-- 新手任务列表头部 -->
    </template>
  </gj-modal>
</template>

<script>
import {isMeaningful} from "@/utils/common";
import { modalMixIn, userGuideMixin } from "@/minxins";
import { getTaskTenant, reverseTaskStatus } from "@/api/guide";
import fireworks from "@/assets/images/userGuide/fireworks.png";
import newbietask from "@/assets/images/userGuide/newbie-task.png";
import leftastigmatism from "@/assets/images/userGuide/leftastigmatism.png";
import taskcompletion from "@/assets/images/userGuide/taskcompletion.png";
import greenStar from "@/assets/images/userGuide/greenStar.png";
import greenStar2 from "@/assets/images/userGuide/orangeStar.png";
import astigmatism from "@/assets/images/userGuide/astigmatism.png";
import goldCoin1 from "@/assets/images/userGuide/goldCoin1.png";
import goldCoin2 from "@/assets/images/userGuide/goldCoin2.png";
import goldCoin3 from "@/assets/images/userGuide/goldCoin3.png";
import {transformToMap} from "@/utils/common";
import { GET_USER_GUIDE_TASK_DATA, SET_USER_GUIDE_TASK_DATA, SET_USER_GUIDE_STATE } from "@/store/mutation-types";
// import {mapGetters} from "vuex";

export default {
  name: "novice-guide",
  mixins: [modalMixIn, userGuideMixin],
  props: {
    activeStep: {
      default: 2,
    },
  },
  data() {
    return {
      loading: false,
      activeNode: 1,
      dataList: [],
      fireworks,
      newbietask,
      leftastigmatism,
      taskcompletion,
      greenStar,
      astigmatism,
      goldCoin1,
      goldCoin2,
      goldCoin3,
      greenStar2,
      taskTypeList: [
        {
          taskTypeCode: "SHOP_MANAGE",
          icon: "icondianpuguanli-1",
          activeIcon: "icondianpuguanli-2",
          taskTypeName: "店铺管理",
          desc: "同步亚马逊数据，为您的亚马逊运营出谋划策",
          taskRate: 0,
          taskStatus: 0,
        },
        {
          taskTypeCode: "ACCOUNT_MANAGE",
          icon: "iconzhanghaoguanli-1",
          activeIcon: "iconzhanghaoguanli-2",
          taskTypeName: "账号管理",
          desc: "小伙伴一起使用系统，为您的运营大计添砖加瓦",
          taskRate: 0,
          taskStatus: 0,
        },
        {
          taskTypeCode: "PRODUCT_MANAGE",
          icon: "iconchanpinguanlian-1",
          activeIcon: "iconchanpinguanlian-2",
          taskTypeName: "产品管理",
          desc: "对应平台商品与仓库产品，为您的补货计划运筹帷幄",
          taskRate: 0,
          taskStatus: 0,
        },
        {
          taskTypeCode: "BASE_DATA",
          icon: "iconjichuziliao-1",
          activeIcon: "iconjichuziliao-2",
          taskTypeName: "基础资料",
          desc: "了解期初数据，为您的需求量身打造",
          taskRate: 0,
          taskStatus: 0,
        },
        {
          taskTypeCode: "COST_ACCOUNTING",
          icon: "iconchengbenhesuan-1",
          activeIcon: "iconchengbenhesuan-2",
          taskTypeName: "成本核算",
          desc: "知晓产品成本，为您的利润核算锦上添花",
          taskRate: 0,
          taskStatus: 0,
        },
        {
          taskTypeCode: "PLUGIN_INSTALL",
          icon: "iconchajiananzhuang-1",
          activeIcon: "iconchajiananzhuang-2",
          taskTypeName: "插件安装",
          desc: "安装积加插件",
          taskRate: 0,
          taskStatus: 0,
        }
      ],
      taskTreeList: [],
      taskActiveIndex: 0,
    };
  },
  created() {
    this.activeNode = this.activeStep;
    this.getTaskData();
  },

  methods: {
    readData() {
      function Set(key, value) {
        const nextTime =
          new Date(new Date().toLocaleDateString()).getTime() + 8640000; //第二天0点时间
        localStorage.setItem(
          key,
          JSON.stringify({ val: value, time: nextTime })
        );
      }
      function Get(key) {
        let val = localStorage.getItem(key);
        if (val) {
          val = JSON.parse(val);
          if (val.time - Date.getTime() > 0) {
            //如果当前时间-第二天0点时间 > 0
          }
        }
      }
    },
    format(percentage) {
      return `${percentage}%`;
    },
    selectTaskIndex(index) {
      this.taskActiveIndex = index;
      document
        .getElementById(`li${index}`)
        .scrollIntoView({ behavior: "smooth" });
    },
    jump(item) {
      this.closeOpen();
      this.$router.push(`${item.path}`);
    },
    scrollTo(code) {
      document.querySelector("#" + code).scrollIntoView({
        behavior: "smooth",
        inline: "nearest",
      });
    },
    closeOpen(val) {
      if (val === "firstLogin") {
        this.$emit("closeOpen", val);
      } else {
        this.$emit("closeOpen");
      }
      this.$gjDestroy();
    },
    getTaskData(){
      this.loading = true
      getTaskTenant().then(data => {
        this.initTaskData(data)
        this.$store.commit(SET_USER_GUIDE_TASK_DATA, data);
      }).complete(()=> { this.loading = false })
    },

    initTaskData(data){
      if (!data) {
        return
      }

      if(!data.taskTypeList || !data.taskList){
        return
      }

      let taskLeftData = transformToMap(data.taskTypeList, 'taskTypeCode');
      let taskRightData = data.taskList;

      let taskTreeList = []

      // 初始化左侧任务列表
      this.taskTypeList.forEach(item => {
        let taskItems = taskLeftData[item.taskTypeCode]
        item = Object.assign(item, taskItems)
        item.taskRate = parseFloat(item.taskRate) * 100
        const taskPoints = taskItems.taskPoints;
        item.gpoint1 = "已获取" + taskPoints + "积点";
        item.gpoint2 = "完成任务可获取" + taskPoints + "积点";

        // 右侧树结构添加父级数据
        taskTreeList.push(item)
      });
      // 初始化右侧子任务列表
      for(let i = 0; i < taskTreeList.length; i++ ) {
        let tasks = taskTreeList[i]
        const taskListItem = this.list.find(j =>{
          return j.taskTypeCode === tasks.taskTypeCode
        })
        if (isMeaningful(taskListItem)){
          tasks = Object.assign(taskListItem, tasks)
          //初始化任务子列表数据
          for(let k = 0; k < tasks.itemArray.length; k++) {
            let item = tasks.itemArray[k];
            let childItem = taskRightData.find(e => e.taskChildCode === item.taskChildCode)
            if (childItem){
              item = Object.assign(item, childItem)
              item.status =  this.getTaskListItemStatus(item.taskStatus)
            }
          }
        }
        taskTreeList[i] = tasks
      }
      this.taskTreeList = taskTreeList
    },

    getTaskListItemStatus(taskStatus){
      let taskStatusNum = 0;
      switch (taskStatus) {
        case 'AWAIT_TURN_ON'://未开启
          taskStatusNum = 3;
          break;
        case 'NOT_STARTED'://未开始
          taskStatusNum = 0;
          break;
        case 'PROCESSING'://进行中
          taskStatusNum = 2;
          break;
        case 'COMPLETED'://已完成
          taskStatusNum = 1;
          break;
      }
      return taskStatusNum;
    },

    startTask(row){
      const itemArray = row.itemArray;
      let taskItem;
      taskItem = itemArray.find(item => {
        return item.status != 1
      })
      if(!taskItem){// 全完成
        taskItem = itemArray[0]
      }else{
        taskItem = itemArray.find(item => {//第一个未开始的任务
          return item.status == 0 || item.status == 2
        })
        if (!taskItem){
          taskItem = itemArray.find(item => {//第一个未开启的任务
            return item.status == 3
          })
        }
      }
      taskItem.taskTypeCode = row.taskTypeCode
      this.jumpToGuidePage(taskItem, ()=>{
        if(taskItem.taskStatus != 'AWAIT_TURN_ON') {
          this.$gjDestroy();
        }
      })
    }

  },
};
</script>

<style scoped lang="scss">
/deep/.loading-container {
  height: 100%;
}

.leftPart {
  width: 360px;
  height: 714px;
  margin-top: 0px;
  margin-left: 0px;
  background: #ffffff;
}
// 左侧背景
.left-astigmatism {
  position: absolute;
  top: 0;
  left: 0;
  .leftastigmatism-bg {
    width: 248px;
    height: 156px;
  }
}
.identification {
  position: absolute;
  top: 60px;
  left: 20px;
  .newbietask-bg {
    width: 118px;
    height: 24px;
  }
}
.fireworks-icon {
  z-index: 100;
  position: absolute;
  top: -64px;
  left: -24px;
  pointer-events: none;
  .fireworks-bg {
    width: 343px;
    height: 428px;
  }
}

.rightmodular {
  overflow: auto;
  height: 620px;
  position: relative;
}
.delay {
  margin-top: 16px;
  margin-left: 1080px;
}
.img12 {
  width: 12px;
  height: 12px;
}
.task-description {
  margin: 16px 24px;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  flex: 1;
  display: flex;
  align-items: center;
}
.task-dividing-Line {
  width: 1px;
  height: 44px;
  background: #e5e6eb;
  // margin-left: 30px;
  margin-top: 12px;
}
.task-status {
  text-align: center;
  color: #00b42a;
  line-height: 18px;
}
.task-status-two {
  color: #1f6eef;
  text-align: center;
  line-height: 18px;
}
.task-status-three {
  color: #999999;
  text-align: center;
  line-height: 18px;
}

.task-box {
  width: 96px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}
.task-name {
  width: 90px;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  margin-bottom: 0;
  text-align: center;
}
.list-tasks {
  display: flex;
  flex-direction: row;
  width: 776px;
  height: 68px;
  background: #ffffff;
  border: 1px solid #ffffff;
  border-radius: 4px;
  z-index: 5;
  box-sizing: border-box;
  color: #666666;
  margin-bottom: 12px;
}
.list-tasks-now {
  background: linear-gradient(90deg, #EDF6FF 0%, #FFFFFF 100%);
  border: 1px solid #BEDAFF;
  box-sizing: border-box;
  color: #333333;
}
.close-window {
  position: absolute;
  top: 20px;
  right: 28px;
  z-index: 100;
  font-size: 20px;
  cursor: pointer;
}
.rightgoldCoin3 {
  position: absolute;
  top: 12px;
  right: 165px;
  z-index: 2;
}
.rightgoldCoin2 {
  position: absolute;
  top: 35px;
  right: 274px;
  z-index: 2;
}
.rightgoldCoin1 {
  position: absolute;
  top: 60px;
  right: 187px;
  z-index: 2;
}
.rightAstigmatism {
  width: 347px;
  height: 163px;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 1;
}

.startBtn {
  z-index: 3;
}
.duration {
  color: #999999;
  margin-left: 12px;
}
.dividing-Line {
  margin-top: 3px;
  width: 1px;
  height: 12px;
  background: #e5e6eb;
  margin-left: 16px;
}
.video-tutorial {
  color: #1f6eef;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-top: 11px;
  margin-left: 4px;
  display: inline-flex;
  cursor: pointer;
  align-items: center;
}
.video-tutorial-text{
  color: #1f6eef;
}
.get-reward-text {
  color: #00b42a;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  margin-left: 6px;
}
.get-reward-text2 {
  color: #f77234;
  font-size: 12px;
  line-height: 18px;
  font-weight: 400;
  margin-left: 6px;
}
.getRewards {
  height: 20px;
  background: linear-gradient(90deg, #e8ffea 0%, rgba(232, 255, 234, 0) 100%);
  border-radius: 2px;
  margin-left: 12px;
}
.getRewards2 {
  height: 20px;
  background: linear-gradient(90deg, #fff3e8 0%, rgba(255, 243, 232, 0) 100%);
  border-radius: 2px;
  margin-left: 12px;
  // display:block;
  // line-height: 20px;
  // text-align: center;
}
.concreteContent {
  font-size: 12px;
  font-weight: 400;
  line-height: 22px;
  color: #333333;
  margin-bottom: 40px;
}
.task-title {
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;
  color: #333333;
}
.task-completion {
  position: absolute;
  right: 0px;
  top: 0;
  z-index: 10;
}
.task-completion-icon {
  width: 69px;
  height: 67px;
}
.speed {
  display: inline-block;
  width: 120px;
}
.progress-bar-progress {
  margin-left: 16px;
}
.task-notes {
  margin: 1px 0px 24px 12px;
  font-size: 12px;
  color: #999999;
  font-weight: 400;
  line-height: 18px;
}
.task-list {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  width: 360px;
  height: 90px;
  cursor: pointer;
  z-index: 3;
  background: #ffffff;
}
.task-list:hover {
  background: #f7f8fa;
}
.task-list-active {
  background: #f7f8fa;
}
.task-list-main {
  width: 268px;
}
.shop {
  margin: 24px 0px 1px 12px;
  color: #999999;
  font-size: 14px;
  font-weight: 600px;
  line-height: 22px;
}
.shop2 {
  margin: 24px 0px 1px 12px;
  color: #333333;
  font-size: 14px;
  font-weight: 600px;
  line-height: 22px;
}
.remarks {
  margin-top: 104px;
  margin-left: 24px;
  margin-bottom: 50px;
  color: #4e5969;
}
.novice-guide /deep/ .el-dialog__body {
  padding: 0;
}

.novice-guide {
  /deep/ .v-modal {
    margin-top: 0 !important;
    opacity: 0.8 !important;
    margin-left: 0 !important;
  }
}

.guides2 {
  /deep/ .gj-modal--guide .el-dialog {
    width: 1200px;
    height: 778px;
    border-radius: 0;
  }
}


.gj-container {
  height: 480px;
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    .btn {
      background: #3384ff;
      box-shadow: 0 4px 8px -4px rgba(51, 132, 255, 0.4);
      border-radius: 4px;
      font-size: 13px;
      color: #ffffff;
      font-weight: 600;
    }
  }
}

.rightPart {
  padding-top: 61px;
  padding-bottom: 24px;
  background: #f7f8fa;
  width: 840px;
  position: relative;
  z-index: 99;
}

@media screen and (max-width: 1440px) {
  .guides2 {
  }
}
</style>
